import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Table } from "@/features/Table";
import { type L1DataUpload, data_upload_columns } from "./columns";
import UploadPopover from "@/components/UploadPopover";
import { type FilterL1DataUploadSchema, L1DataUploadFilter } from "./filter";
import { L1DataUploadNew } from "./new";
import { useQueryClient } from "@tanstack/react-query";

export const L1DataUploadTable = () => {
  const [searchParams] = useSearchParams();
  const [files, setFiles] = useState<File[]>([]);
  const [selectedConfig, setSelectedConfig] = useState<string | null>(null);
  const client = searchParams.get("client") || "l1";
  const table_name = "l1_data_upload";

  const QueryClient = useQueryClient();
  const refreshList = async () => {
    // In v5, this invalidates all queries whose key starts with the prefix
    await QueryClient.invalidateQueries({
      queryKey: [client, table_name, "get"],
    });
  };

  return (
    <Table<L1DataUpload, FilterL1DataUploadSchema>
      label="Chargement de fichiers"
      client={client}
      table_name={table_name}
      columns={data_upload_columns}
      filter={<L1DataUploadFilter />}
      disable_translations_request={true}
      new_item={
        <UploadPopover
          uploader={({ setIsOpen }) => (
            <L1DataUploadNew
              setIsOpen={setIsOpen}
              files={files}
              setFiles={setFiles}
              selectedConfig={selectedConfig}
              setSelectedConfig={setSelectedConfig}
              onSuccess={async () => {
                await refreshList();
              }}
            />
          )}
        />
      }
    />
  );
};
